import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import { selectIsFilterShown } from 'redux/selectors/workspace';
import { setFilterShown } from 'redux/actions/workspace';

const mapStateToProps = (state: StateType) => ({
  isFilterShown: selectIsFilterShown(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    setFilterShown,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
